<template>
  <v-simple-table class="mt-2" dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-center body-2 font-weight-bold text-uppercase">
            Descripción
          </th>
          <th class="text-center body-2 font-weight-bold text-uppercase">
            Precio
          </th>
        </tr>
      </thead>
      <tbody
        v-for="(item, i) in detallePromocion($route.params.articulo)"
        :key="i"
      >
        <tr>
          <td class="text-left">
            <span class="font-weight-bold ml-n3">
              {{ `${$vuetify.breakpoint.mdAndUp ? "PROMOCION N°:" : "REF:"}` }}
            </span>
            {{ item.codigo }} {{ `- TIPO: ${item.TipoPromo}` }}
          </td>
          <td v-if="dataUser.VerPrecios[tipoMoneda]" class="text-right">
            {{ simboloMoneda[tipoMoneda] }}
            <span class="text-decoration-line-through body-2 font-weight-bold">
              {{ Articulo[0]["Precio"][tipoMoneda] | numeral("0,0.00") }}
            </span>
          </td>
        </tr>
        <tr>
          <td class="text-left">
            <span class="font-weight-bold ml-n3 mr-1"> DESCUENTO:</span>
            {{ item.descuento }} %
          </td>
          <td v-if="dataUser.VerPrecios[tipoMoneda]" class="text-right">
            {{ simboloMoneda[tipoMoneda] }}
            <span class="body-1 font-weight-bold">
              {{ item["PrecioExt-paq"] | numeral("0,0.00") }}
            </span>
          </td>
        </tr>
        <tr>
          <td class="text-left">
            <span class="font-weight-bold ml-n3 mr-1"> CANT MINIMA:</span>
            <span class=" mr-1">{{ item["cantidad-min"] }}</span>
            <Paleta v-if="item.UniVenta===`M2`"/> 
            <Paquete v-if="item.UniVenta!==`M2`"/> 
          </td>
          <td v-if="dataUser.VerPrecios[tipoMoneda]" class="text-right">
            <btnPromo
              :infoproducto="Articulo[0]"
              @sel-promo="cantPromo"
              :codArt="$route.params.articulo"
              :codPromo="item.codigo"
              :tipoConsulta="2"
              :titulo="`CARGAR PROMOCIÓN`"
            />
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import btnPromo from "../botonselpromo";
import { Paleta, Paquete } from "../Icons";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    btnPromo,
    Paleta,
    Paquete,
  },
  data() {
    return {
      promoDetalle: [],
    };
  },
  methods: {
    cantPromo(datos) {
      this.promoDetalle = datos;
    },
  },
  computed: {
    ...mapState([
      "Articulo",
      "Cliente",
      "tipoMoneda",
      "simboloMoneda",
      "dataUser",
    ]),
    ...mapGetters(["filterpromoart"]),
    detallePromocion: function () {
      //articulo
      return function (id) {
        if (this.filterpromoart) {
          return this.filterpromoart.filter((x) => id === x["articulo"]);
        }
      };
    },
  },
};
</script>

<style></style>
